/* Store-only ZIP: photos are already compressed; preserve the CDN response bytes. */
(function () {
  'use strict';
  function zip(files) {
    var chunks = [], directory = [], offset = 0;
    files.forEach(function (file) {
      var name = new TextEncoder().encode(file.name), data = file.data, crc = 0xffffffff;
      for (var i = 0; i < data.length; i++) {
        crc ^= data[i];
        for (var bit = 0; bit < 8; bit++) crc = (crc >>> 1) ^ ((crc & 1) ? 0xedb88320 : 0);
      }
      crc = (crc ^ 0xffffffff) >>> 0;
      var local = new Uint8Array(30 + name.length), l = new DataView(local.buffer);
      l.setUint32(0, 0x04034b50, true); l.setUint16(4, 20, true);
      l.setUint16(6, 0x800, true); l.setUint16(12, 33, true);
      l.setUint32(14, crc, true); l.setUint32(18, data.length, true); l.setUint32(22, data.length, true);
      l.setUint16(26, name.length, true); local.set(name, 30);
      var central = new Uint8Array(46 + name.length), c = new DataView(central.buffer);
      c.setUint32(0, 0x02014b50, true); c.setUint16(4, 20, true); c.setUint16(6, 20, true);
      c.setUint16(8, 0x800, true); c.setUint16(14, 33, true);
      c.setUint32(16, crc, true); c.setUint32(20, data.length, true); c.setUint32(24, data.length, true);
      c.setUint16(28, name.length, true); c.setUint32(42, offset, true); central.set(name, 46);
      chunks.push(local, data); directory.push(central); offset += local.length + data.length;
    });
    var end = new Uint8Array(22), e = new DataView(end.buffer);
    e.setUint32(0, 0x06054b50, true); e.setUint16(8, files.length, true); e.setUint16(10, files.length, true);
    e.setUint32(12, directory.reduce(function (n, b) { return n + b.length; }, 0), true);
    e.setUint32(16, offset, true);
    return new Blob(chunks.concat(directory, [end]), { type: 'application/zip' });
  }
  document.addEventListener('click', async function (event) {
    var button = event.target.closest('[data-download-photos]');
    if (!button || button.disabled) return;
    var area = button.closest('[data-photo-downloads]'), status = area.querySelector('[role="status"]');
    var links = Array.from(area.querySelectorAll('[data-original-photo]'));
    var sku = document.getElementById('sku');
    var base = ((sku && sku.textContent.trim()) || area.dataset.productHandle).replace(/[^a-zA-Z0-9_-]+/g, '-').slice(0, 100) || 'product';
    button.disabled = true;
    var files = [], total = 0;
    try {
      for (var i = 0; i < links.length; i++) {
        status.textContent = 'Preparing photo ' + (i + 1) + ' of ' + links.length + '…';
        var controller = new AbortController(), timer = setTimeout(function () { controller.abort(); }, 30000);
        try {
          var response = await fetch(links[i].dataset.originalPhoto, { signal: controller.signal });
          if (!response.ok) throw new Error('Photo unavailable');
          var type = (response.headers.get('content-type') || '').split(';')[0];
          var extensions = { 'image/jpeg': 'jpg', 'image/png': 'png', 'image/webp': 'webp', 'image/avif': 'avif', 'image/gif': 'gif' };
          if (!extensions[type]) throw new Error('Unsupported photo');
          var reader = response.body.getReader(), parts = [], length = 0;
          while (true) {
            var part = await reader.read();
            if (part.done) break;
            total += part.value.length; length += part.value.length;
            if (total > 128 * 1024 * 1024) { controller.abort(); throw new Error('Large archive'); }
            parts.push(part.value);
          }
          var bytes = new Uint8Array(length), position = 0;
          parts.forEach(function (part) { bytes.set(part, position); position += part.length; });
          files.push({ name: base + '-' + String(i + 1).padStart(2, '0') + '.' + extensions[type], data: bytes });
        } finally { clearTimeout(timer); }
      }
      var url = URL.createObjectURL(zip(files)), a = document.createElement('a');
      a.href = url; a.download = base + '-photos.zip'; document.body.appendChild(a); a.click(); a.remove();
      setTimeout(function () { URL.revokeObjectURL(url); }, 60000);
      status.textContent = 'Your photo ZIP is ready. Check your downloads.';
    } catch (error) {
      status.textContent = 'Unable to prepare the ZIP. Please try again.';
    } finally { button.disabled = false; }
  });
})();
